import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { useAppDispatch } from '../../ui/pages/store';
import { FileFragments } from '../../graphql/file.graphql';
import { FileEntity } from '../../types/file';
import { fileSlice } from '../../providers/FileProvider';

const fileSubscription = gql`
  subscription fileNotification($companyId: String!) {
    fileNotification(companyId: $companyId) {
      companyId
      entities {
        ...FileEntity
      }
      topic
      date
    }
  }
  ${FileFragments.file}
`;

export class FileNotificationResponse extends forNotification<FileEntity>('fileNotification') {}

export default function FileNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: fileNotification } = useSubscription<FileNotificationResponse>(fileSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleFileNotification = (notification?: FileNotificationResponse) => {
    if (!notification?.fileNotification) return;
    const fileNotification = notification.fileNotification;

    switch (fileNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(fileSlice.actions.add(fileNotification.entities));
        break;
      case 'DELETE':
        dispatch(fileSlice.actions.delete(fileNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleFileNotification(fileNotification);
  }, [fileNotification]);

  return <></>;
}
